import * as React from "react";

function IconArrowsSort({
  size = 24,
  color = "currentColor",
  stroke = 2,
  ...props
}) {
  return <svg className="icon icon-tabler icon-tabler-arrows-sort" width={size} height={size} viewBox="0 0 24 24" strokeWidth={stroke} stroke={color} fill="none" strokeLinecap="round" strokeLinejoin="round" {...props}><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M3 9l4-4l4 4m-4 -4v14" /><path d="M21 15l-4 4l-4-4m4 4v-14" /></svg>;
}

export default IconArrowsSort;